import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { getEmployment, getEmployments } from '../../../../../global/ducks/benadmin-api';
import { LockedPageKeys } from '../../../../../global/models/locked-page-model';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { BillingAccount } from '../../billing-accounts/billing-accounts-models';
import { Employment, EmploymentState } from '../../employment/employment-model';
import { dispatchSetEmployment, dispatchSetEmploymentFailed } from '../../employment/employment-slice';
import { MidyearEnrollmentState } from '../mid-year-model';
import { fetchMidYearInfo } from '../mid-year-requests';
import { clearMidYearState } from '../mid-year-slices';



export function useMidYearState() {

	const guid = useSelector<TcsmStates, string>(state => state.employmentState?.currentEmployee?.guid);
	const groupId = useSelector<TcsmStates, number>(state => state.groupsState?.currentGroup?.group_id);
	const midYearState = useSelector<TcsmStates, MidyearEnrollmentState>(state => state.midYearEnrollment);
	const currentBillingAccount = useSelector<TcsmStates, BillingAccount>(state => state?.billingAccountsState?.currentBillingAccount);
	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state?.employmentState);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!midYearState.midYearLoaded && guid && groupId) {
			fetchMidYearInfo(dispatch, guid, groupId);
		}
	}, [guid, groupId]);

	useEffect(() => {
		if (!employmentState?.employmentLoaded && guid && currentBillingAccount?.account_owner_client_number) {
			dispatch(getEmployments(
				guid,
				(response) => {
					const match = response?.data?.find(employment => employment?.employer_client_number === currentBillingAccount?.account_owner_client_number);
					dispatch(getEmployment(guid, match?.id, dispatchSetEmployment(dispatch), () => dispatchSetEmploymentFailed(dispatch)));
				},
			));
		}
	}, [guid]);

	useEffect(() => {
		return function cleanup() {
			dispatch(apiErrorClear());
			dispatch(clearMidYearState());
		};
	}, [guid]);


	return midYearState.midYearLoaded;
}


export function useMidYearLockState() {
	const employment = useSelector<TcsmStates, Employment>(state => state?.employmentState?.currentEmployment);

	return employment?.locks[LockedPageKeys.Ghl]?.length > 0;
}